module.exports = __webpack_public_path__ + "static/other/lab_diagnosis_draw_blood_scene.296f3997.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/maps/labDiagnosisGame/lab_diagnosis_draw_blood_scene.json
// module id = 2223
// module chunks = 0